import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Check, BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import { AppShell } from "@/components/AppShell";
import { Loader } from "@/components/Loader";

export default function Diario() {
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    api.get("/diary").then(({ data }) => setEntries(data.entries)).catch(() => setEntries([]));
  }, []);

  if (!entries) return <Loader />;
  const withNotes = entries.filter((e) => (e.nota && e.nota.trim()) || e.completed);

  return (
    <AppShell title="Diario" greeting="Le tue riflessioni">
      <div className="px-5 pt-6">
        {withNotes.length === 0 ? (
          <div className="rounded-2xl border border-[#27272A] bg-[#121215] p-8 text-center">
            <BookOpen size={28} className="mx-auto text-[#8A8E96]" />
            <p className="mt-3 a2g-read text-base text-[#B4B4BC]">
              Nessuna riflessione ancora. Rispondi alla "domanda del giorno" nei tuoi momenti per riempire il diario.
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {entries.map((e, i) => {
              const hasNote = e.nota && e.nota.trim();
              if (!hasNote && !e.completed) return null;
              return (
                <motion.div
                  key={e.day}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: i * 0.04 }}
                  className="rounded-2xl border border-[#27272A] bg-[#121215] p-5"
                  data-testid={`diary-entry-${e.day}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="text-[12px] font-semibold uppercase tracking-wider text-[#8A8E96]">{e.date_label || `Giorno ${e.day}`}</span>
                    {e.completed && (
                      <span className={`inline-flex items-center gap-1 text-[12px] font-semibold ${e.status_label ? "text-[#B4B4BC]" : "text-[#10B981]"}`} data-testid={`diary-status-${e.day}`}>
                        {!e.status_label && <Check size={12} />} {e.status_label ? `Giornata chiusa · ${e.status_label}` : "Completato"}
                      </span>
                    )}
                  </div>
                  <p className="a2g-read mt-2 text-lg leading-snug text-[#F4F4F5] font-semibold">{e.domanda}</p>
                  {hasNote ? (
                    <p className="mt-3 a2g-read rounded-xl border border-[#27272A] bg-[#0D0D0F] p-3 text-base leading-relaxed text-[#D4D4D8]">
                      {e.nota}
                    </p>
                  ) : (
                    <p className="mt-2 text-sm text-[#8A8E96]">Nessuna nota scritta per questo giorno.</p>
                  )}
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </AppShell>
  );
}
